import {
    IS_GET_LEAGUES_LOADING,
    LEAGUES_FETCH_DATA_SUCCESS,
    LEAGUES_HAS_ERROR,
    IS_GET_LEAGUE_MEMBERS_LOADING,
    IS_CREATE_LEAGUE_LOADING,
    IS_JOIN_LEAGUE_LOADING,
    IS_LEAVE_LEAGUE_LOADING,
    IS_RELAUNCH_LEAGUE_LOADING,
    IS_RE_JOIN_LEAGUE_LOADING,
    IS_DELETE_LEAGUE_LOADING,
    IS_PREVIOUS_SEASON_DELETE_LEAGUE_LOADING,
    IS_PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_LOADING,
    IS_SUSPEND_LEAGUE_LOADING,
    IS_REMOVE_SUSPENSION_LOADING,
    LEAGUE_MEMBERS_HAS_ERROR,
    CREATE_LEAGUE_HAS_ERROR,
    JOIN_LEAGUE_HAS_ERROR,
    LEAVE_LEAGUE_HAS_ERROR,
    RELAUNCH_LEAGUE_HAS_ERROR,
    RE_JOIN_LEAGUE_HAS_ERROR,
    DELETE_LEAGUE_HAS_ERROR,
    PREVIOUS_SEASON_DELETE_LEAGUE_HAS_ERROR,
    PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_HAS_ERROR,
    SUSPEND_LEAGUE_HAS_ERROR,
    REMOVE_SUSPENSION_HAS_ERROR,
    LEAGUE_MEMBERS_FETCH_DATA_SUCCESS,
    CREATE_LEAGUE_FETCH_DATA_SUCCESS,
    JOIN_LEAGUE_FETCH_DATA_SUCCESS,
    LEAVE_LEAGUE_FETCH_DATA_SUCCESS,
    RELAUNCH_LEAGUE_FETCH_DATA_SUCCESS,
    RE_JOIN_LEAGUE_FETCH_DATA_SUCCESS,
    DELETE_LEAGUE_FETCH_DATA_SUCCESS,
    PREVIOUS_SEASON_DELETE_LEAGUE_FETCH_DATA_SUCCESS,
    PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_FETCH_DATA_SUCCESS,
    SUSPEND_LEAGUE_FETCH_DATA_SUCCESS,
    REMOVE_SUSPENSION_FETCH_DATA_SUCCESS,
    IS_PUBLIC_LEAGUES_LOADING,
    PUBLIC_LEAGUES_FETCH_DATA_SUCCESS,
    PUBLIC_LEAGUES_HAS_ERROR,
    IS_LEAGUE_LEADERBOARD_LOADING,
    LEAGUE_LEADERBOARD_HAS_ERROR,
    LEAGUE_LEADERBOARD_FETCH_DATA_SUCCESS,
    IS_RENAME_LEAGUE_LOADING,
    RENAME_LEAGUE_HAS_ERROR,
    RENAME_LEAGUE_FETCH_DATA_SUCCESS,
    LEAGUE_LEADERBOARD_PUBLIC_FETCH_DATA_SUCCESS,
    LEAGUE_LEADERBOARD_PUBLIC_HAS_ERROR,
    LEAGUE_LEADERBOARD_RANK__FETCH_DATA_SUCCESS,
    LEAGUE_LEADERBOARD_RANK__HAS_ERROR,
    IS_GET_OTHERS_TEAM_LOADING,
    GET_OTHERS_TEAM_SUCCESS,
    GET_OTHERS_TEAM_HAS_ERROR,
    UPDATE_FAV_TEAM_LOADING,
    UPDATE_FAV_TEAM_ERROR,
    UPDATE_FAV_TEAM_SUCCESS,
} from './../constants/action-types';
import common from "../common";

const initialState = {
    isLeaguesLoading: false,
    isPublicLeagueLoading: false,
    isLeagueLeaderBoardLoading: false,
    isLeagueMemberLoading: false,
    isCreateLeagueLoading: false,
    isJoinLeagueLoading: false,
    isLeaveLeagueLoading: false,
    isRelaunchLeagueLoading: false,
    isReJoinLeagueLoading: false,
    isDeleteLeagueLoading: false,
    isPreviousSeasonDeleteLeagueLoading: false,
    isPreviousSeasonMemberDeleteLoading: false,
    isSuspendLeagueLoading: false,
    isRemoveSuspensionLoading: false,
    isOthersTeamLoading: false,
    leaguesHasError: false,
    publicLeaguesHasError: false,
    leagueLeaderBoardHasError: false,
    leagueMembersHasError: false,
    createLeagueHasError: false,
    joinLeagueHasError: false,
    leaveLeagueHasError: false,
    relaunchLeagueHasError: false,
    reJoinLeagueHasError: false,
    deleteLeagueHasError: false,
    previousSeasonDeleteLeagueHasError: false,
    previousSeasonMemberDeleteHasError: false,
    suspendLeagueHasError: false,
    removeSuspensionHasError: false,
    getPublicLeaderBoardHasError: false,
    getPublicLeaderBoardRankHasError: false,
    othersTeamHasError: false,
    leagues: [],
    leagueMembers: [],
    publicLeagues: [],
    leagueLeaderBoard: [],
    publicLeaderBoard: [],
    publicRankLeaderBoard: [],
    createLeagueResponse: null,
    joinLeagueResponse: null,
    leaveLeagueResponse: null,
    relaunchLeagueResponse: null,
    reJoinLeagueResponse: null,
    deleteLeagueResponse: null,
    previousSeasonDeleteLeagueResponse: null,
    previousSeasonMemberDeleteResponse: null,
    suspendResponse: null,
    removeSuspensionResponse: null,
    isRenameLeagueLoading: false,
    renameLeagueHasError: false,
    updateLeagueNameResponse: null,
    othersTeam: {},
};
export default function leaguesData(state = initialState, action) {
    switch (action.type) {
        case IS_GET_LEAGUES_LOADING: {
            return { ...state, isLeaguesLoading: action.payload };
        }
        case IS_PUBLIC_LEAGUES_LOADING: {
            return { ...state, isLeaguesLoading: action.payload };
        }
        case IS_LEAGUE_LEADERBOARD_LOADING: {
            return { ...state, isLeagueLeaderBoardLoading: action.payload };
        }
        case LEAGUES_HAS_ERROR: {
            return { ...state, leaguesHasError: action.payload };
        }
        case PUBLIC_LEAGUES_HAS_ERROR: {
            return { ...state, publicLeaguesHasError: action.payload };
        }
        case LEAGUE_LEADERBOARD_HAS_ERROR: {
            return { ...state, leagueLeaderBoardHasError: action.payload };
        }
        case LEAGUES_FETCH_DATA_SUCCESS: {
            return { ...state, leagues: action.payload['Data']['Value'] };
        }
        case PUBLIC_LEAGUES_FETCH_DATA_SUCCESS: {
            // const publicLeagues = action.payload['Data']['Value'];
            const publicLeagues = action.payload['Data']['ValueNew'] ? action.payload['Data']['ValueNew'] : action.payload['Data']['Value'];
            common.setLocalStorage('publicLeagues', publicLeagues);
            return { ...state, publicLeagues };
        }
        case LEAGUE_LEADERBOARD_FETCH_DATA_SUCCESS: {
            return { ...state, leagueLeaderBoard: action.payload['Data']['Value'] };
        }
        case IS_GET_LEAGUE_MEMBERS_LOADING: {
            return { ...state, isLeagueMemberLoading: action.payload };
        }
        case IS_CREATE_LEAGUE_LOADING: {
            return { ...state, isCreateLeagueLoading: action.payload };
        }
        case IS_JOIN_LEAGUE_LOADING: {
            return { ...state, isJoinLeagueLoading: action.payload };
        }
        case IS_LEAVE_LEAGUE_LOADING: {
            return { ...state, isLeaveLeagueLoading: action.payload };
        }
        case IS_RELAUNCH_LEAGUE_LOADING: {
            return { ...state, isRelaunchLeagueLoading: action.payload };
        }
        case IS_RE_JOIN_LEAGUE_LOADING: {
            return { ...state, isReJoinLeagueLoading: action.payload };
        }
        case IS_DELETE_LEAGUE_LOADING: {
            return { ...state, isDeleteLeagueLoading: action.payload };
        }
        case IS_PREVIOUS_SEASON_DELETE_LEAGUE_LOADING: {
            return { ...state, isPreviousSeasonDeleteLeagueLoading: action.payload };
        }
        case IS_PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_LOADING: {
            return { ...state, isPreviousSeasonMemberDeleteLoading: action.payload };
        }
        case IS_SUSPEND_LEAGUE_LOADING: {
            return { ...state, isSuspendLeagueLoading: action.payload };
        }
        case IS_REMOVE_SUSPENSION_LOADING: {
            return { ...state, isRemoveSuspensionLoading: action.payload };
        }
        case LEAGUE_MEMBERS_HAS_ERROR: {
            return { ...state, leagueMembersHasError: action.payload };
        }
        case CREATE_LEAGUE_HAS_ERROR: {
            return { ...state, createLeagueHasError: action.payload };
        }
        case JOIN_LEAGUE_HAS_ERROR: {
            return { ...state, joinLeagueHasError: action.payload };
        }
        case LEAVE_LEAGUE_HAS_ERROR: {
            return { ...state, leaveLeagueHasError: action.payload };
        }
        case RELAUNCH_LEAGUE_HAS_ERROR: {
            return { ...state, relaunchLeagueHasError: action.payload };
        }
        case RE_JOIN_LEAGUE_HAS_ERROR: {
            return { ...state, reJoinLeagueHasError: action.payload };
        }
        case DELETE_LEAGUE_HAS_ERROR: {
            return { ...state, deleteLeagueHasError: action.payload };
        }
        case PREVIOUS_SEASON_DELETE_LEAGUE_HAS_ERROR: {
            return { ...state, previousSeasonDeleteLeagueHasError: action.payload };
        }
        case PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_HAS_ERROR: {
            return { ...state, previousSeasonMemberDeleteHasError: action.payload };
        }
        case SUSPEND_LEAGUE_HAS_ERROR: {
            return { ...state, suspendLeagueHasError: action.payload };
        }
        case REMOVE_SUSPENSION_HAS_ERROR: {
            return { ...state, removeSuspensionHasError: action.payload };
        }
        case LEAGUE_MEMBERS_FETCH_DATA_SUCCESS: {
            return { ...state, leagueMembers: action.payload['Data']['Value'] };
        }
        case CREATE_LEAGUE_FETCH_DATA_SUCCESS: {
            return { ...state, createLeagueResponse: action.payload };
        }
        case JOIN_LEAGUE_FETCH_DATA_SUCCESS: {
            return { ...state, joinLeagueResponse: action.payload };
        }
        case LEAVE_LEAGUE_FETCH_DATA_SUCCESS: {
            return { ...state, leaveLeagueResponse: action.payload };
        }
        case RELAUNCH_LEAGUE_FETCH_DATA_SUCCESS: {
            return { ...state, relaunchLeagueResponse: action.payload };
        }
        case RE_JOIN_LEAGUE_FETCH_DATA_SUCCESS: {
            return { ...state, reJoinLeagueResponse: action.payload };
        }
        case DELETE_LEAGUE_FETCH_DATA_SUCCESS: {
            return { ...state, deleteLeagueResponse: action.payload };
        }
        case PREVIOUS_SEASON_DELETE_LEAGUE_FETCH_DATA_SUCCESS: {
            return { ...state, previousSeasonDeleteLeagueResponse: action.payload };
        }
        case PREVIOUS_SEASON_MEMBER_DELETE_LEAGUE_FETCH_DATA_SUCCESS: {
            return { ...state, previousSeasonMemberDeleteResponse: action.payload };
        }
        case SUSPEND_LEAGUE_FETCH_DATA_SUCCESS: {
            return { ...state, suspendResponse: action.payload };
        }
        case REMOVE_SUSPENSION_FETCH_DATA_SUCCESS: {
            return { ...state, removeSuspensionResponse: action.payload };
        }
        case IS_RENAME_LEAGUE_LOADING: {
            return { ...state, isRenameLeagueLoading: action.payload };
        }
        case RENAME_LEAGUE_HAS_ERROR: {
            return { ...state, renameLeagueHasError: action.payload };
        }
        case RENAME_LEAGUE_FETCH_DATA_SUCCESS: {
            return { ...state, updateLeagueNameResponse: action.payload };
        }
        case LEAGUE_LEADERBOARD_PUBLIC_HAS_ERROR: {
            return { ...state, getPublicLeaderBoardHasError: action.payload };
        }
        case LEAGUE_LEADERBOARD_PUBLIC_FETCH_DATA_SUCCESS: {
            return { ...state, publicLeaderBoard: action.payload['Data']['Value'] };
        }
        case LEAGUE_LEADERBOARD_RANK__HAS_ERROR: {
            return { ...state, getPublicLeaderBoardRankHasError: action.payload };
        }
        case LEAGUE_LEADERBOARD_RANK__FETCH_DATA_SUCCESS: {
            return { ...state, publicRankLeaderBoard: action.payload['Data']['Value'] };
        }
        case IS_GET_OTHERS_TEAM_LOADING: {
            return { ...state, isOthersTeamLoading: action.payload };
        }
        case GET_OTHERS_TEAM_SUCCESS: {
            return { ...state, othersTeam: action.payload['Data']['Value'] };
        }
        case GET_OTHERS_TEAM_HAS_ERROR: {
            return { ...state, othersTeamHasError: action.payload };
        }
        case UPDATE_FAV_TEAM_LOADING: {
            return { ...state, isUpdateFavTeamLoading: action.payload };
        }
        case UPDATE_FAV_TEAM_SUCCESS: {
            return { ...state, updateFavTeamResp: action.payload['Data'] };
        }
        case UPDATE_FAV_TEAM_ERROR: {
            return { ...state, isUpdateFavTeamError: action.payload };
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/LeaguesReducer.js